<script>
    import DocumentationField from '$lib/components/forms/DocumentationField.svelte'
    import { Form, Typography } from '$lib/components/UI'
    import { confImp } from '$lib/conf'
    export let data = {}
    export let conditions = {}
    let docdata = {} //structuredClone(data)
    const intialData = Object.entries(data)
        .filter(
            ([k, v]) =>
                k.indexOf('docu_') !== -1 && v?.files && v.files.length > 0
        )
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    export let validations = {}
    const schema = {
        condicion_iva: {
            title: 'Impuesto al IVA',
            name: 'docu_condicion_imp_iva_ii',
            id: 'condicion_imp_iva_ii',
        },
        condicion_iibb: {
            title: 'Impuesto a los Ingresos Brutos',
            name: 'docu_condicion_imp_ingresos_ii',
            id: 'condicion_imp_ingresos_ii',
        },
        condicion_ganancias: {
            title: 'Impuesto a las Ganancias',
            name: 'docu_condicion_imp_ganancias_ii',
            id: 'condicion_imp_ganancias_ii',
        },
    }
    $: data = Object.entries(docdata)
        .filter(([_, v]) =>
            v instanceof Array && v.length > 0
                ? v.every((x) => 'files' in x && x?.files?.length > 0)
                : 'files' in v && v?.files?.length > 0
        )
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    $: console.log({ docdata, data })
</script>

<Form bind:data={docdata} quiet>
    <div>
        <Typography type="h4" style="margin-bottom: 0px"
            >Documentacion General</Typography
        >
        {#each confImp.general as conf}
            <DocumentationField
                value={conf.name in intialData ? intialData[conf.name] : {}}
                {...conf}
                bind:valid={validations[conf.name]}
                optional
                deleteable
            />
        {/each}
        {#each Object.entries(schema) as [type, { name, id, title }] (id)}
            {#if conditions[id] in confImp[type]}
                <Typography type="h4" style="margin-bottom: 0px"
                    >{title}</Typography
                >
                <DocumentationField
                    {...confImp[type][conditions[id]]}
                    value={intialData[name] || {}}
                    labelSuffix=""
                    {name}
                    optional
                    deleteable
                    bind:valid={validations[id]}
                />
            {/if}
        {/each}
        {#if confImp.otros.length > 0}
            {@const configOthers = confImp.otros[0]}
            <Typography type="h4" style="margin-bottom: 0px"
                >Otra documentación</Typography
            >
            <DocumentationField
                bind:valid={validations[configOthers.name]}
                value={intialData[configOthers.name] || {}}
                {...configOthers}
                on:delete={(_) => {
                    delete data[configOthers.name]
                    delete validations[configOthers.name]
                }}
            />
        {/if}
    </div>
</Form>

<style>
    div {
        position: relative;
        width: 100%;
        flex-direction: column;
        /* height: fit-content; */
        display: flex;
        padding: 10px 0 0 0;
        justify-content: center;
        align-items: flex-start;
        gap: 25px;
    }
</style>
